export const UNBOX_BACKGROUND_COLOR_CLASS =  {
    'd99700': 'unbox-gold',
    'c9005a': 'unbox-red',
    '7900df': 'unbox-purple',
    'c700df': 'unbox-pink',
    '2a5aab': 'unbox-blue',
    'b4b4b2': 'unbox-white',
};